import shiftAcceptanceIndicatorHtml from './shiftAcceptanceIndicatorComponent.html';

class ShiftAcceptanceIndicatorCtrl {
  constructor(ShiftAcceptanceUtils) {
    'ngInject';

    Object.assign(this, { ShiftAcceptanceUtils });
  }

  isRejectedStatus() {
    return this.ShiftAcceptanceUtils.isRejectedStatus(this.shift);
  }
}

export default {
  controller: ShiftAcceptanceIndicatorCtrl,
  controllerAs: 'ctrl',
  bindings: {
    shift: '<',
    goToConfirmationState: '&',
  },
  templateUrl: shiftAcceptanceIndicatorHtml,
};
